import React from "react";
import { useTranslation } from "react-i18next";

import { ProductDigitalTradingIntroSection } from "./intro-section/ProductDigitalTradingIntroSection";
import { ProductDigitalTradingBannerSection } from "./banner-section/ProductDigitalTradingBannerSection";

export const ProductDigitalTradingView: React.FC = () => {
  const { t } = useTranslation();

  //   const selectedProduct = products.find((p) => p.value === selectedAwenturesProductCode);
  //   if (!loading && called && !hasAvailableOffers(products)) {
  //     return (
  //       <NotFoundView text={t("Product not available, you will be redirected back to homepage after few seconds...")} />
  //     );
  //   }

  return (
    <>
      <ProductDigitalTradingBannerSection />

      <ProductDigitalTradingIntroSection />
    </>
  );
};
